import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=b68b37f4&"
import script from "./RadioItem.vue?vue&type=script&lang=js&"
export * from "./RadioItem.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/form.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports